import React, {Component} from 'react';
import {connect} from "react-redux";
import $ from "jquery";
import {ConfirmPopupTypes, UserPopupTypes, QuoteRequestType} from "../../visComponents/constants";
import {FormattedMessage, injectIntl} from "react-intl";

import {
  toggleUserPopup,
  toggleAdditionalFields,
  setUserPhoneNumberValidated,
  changeMessageBoxState,
  showCheckoutLayout,
  changeUserInfoErrors
} from "../../../actions/actionFunctions";
import {userLogin, userRegister, resetUserPassword, getEmployees} from "../../../api/user-api";
import UserFields from "./userFields";
import {VIEW} from "./constants";
import TwoFAView from './../../common/twoFactorAuthView';
import {getCurrentLayout} from "../../appLayout";
import {browserIsSafari, isIframe} from "../../../misc/helpers";
import Misc from "../../../misc/misc";
import Analytics from './../../../analytics';
import ActionTypes from "../../../misc/actionTypes";
import ConfirmationScheduleView from "../../common/calendar/confirmationScheduleView";
import {renderConfirmPopup} from "../../../api/api-popups";
import {getImagePromiseFromLayout} from "../../../misc/getCanvasImageFromLayout";
import Config from "../../../config";
import PrivacyPolicyTerms from "./privacyPolicyTerms";

class UserPopup extends Component {
  fabricatorSettings = null;
  constructor(props) {
    super(props);
    this.state = {
      view: Config.isDevMode() ? VIEW.login : VIEW.register,
      imageSrc: "",
      termsSelected: true,
      inputFocused: ""
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userPopupOpened && !this.props.userPopupOpened) {
      if (nextProps.bvVisited) {
        $(window).trigger(ActionTypes.REMOVE_GREEN_ZONE_ON_CANVAS, this.setCanvasImage);
      } else {
        this.setCanvasImage();
      }
      const lightbox = $('.user-popup');
      const image = $('.user-popup-photo');
      image.hide();
      lightbox.length && lightbox.hide().fadeIn(600, () => {
        image.show();
      });
      window.allowClickLeadCapturePopup = true;
    } else if (!nextProps.userPopupOpened && this.props.userPopupOpened) {
      this.setState({
        imageSrc: ''
      });
    }
    if (nextProps.showPrivacyPolicy && !this.props.showPrivacyPolicy) {
      this.setState({
        view: VIEW.terms
      });
    }
  }

  setCanvasImage = () => {
    const layout = getCurrentLayout();
    getImagePromiseFromLayout(layout)
      .then((response) => {
        this.setState({
          imageSrc: response || this.props.staticCanvasImage || ""
        });
      });
  };

  handleUserPopupToggle = () => {
    Analytics.sendClickEvent('user-popup-toggle');
    $(window).trigger(ActionTypes.USER_POPUP_CLOSED);
    if (this.state.view === VIEW.terms) {
      this.setState({
        view: VIEW.register
      });
    }
    this.props.toggleUserPopup({
      userPopupOpened: false,
      showPrivacyPolicy: false
    })
  };

  checkFieldsForErrors = () => {
    const {userInfo, changeUserInfoErrors, fabricatorData} = this.props;

    let neededFields = [];
    let errorsExist = false;
    switch (this.state.view) {
      case VIEW.login:
      case VIEW.reset:
        neededFields = ["email"];
        break;
      case VIEW.register:
        neededFields = ["firstName", "email", "phoneNumber", "postal"];
        break;
      default:
        break;
    }
    neededFields.forEach((property) => {
      const errors = Misc.getValidationErrors(userInfo[property], property, fabricatorData);
      changeUserInfoErrors({
        [property]: errors
      });
      if (errors.length) {
        errorsExist = true;
      }
    })
    return errorsExist
  }

  handleSubmit = ({showConfirmationPopup = false, showSchedule = false,
                    quoteRequestType = QuoteRequestType.RegularDesign} = {}) => {
    const layout = getCurrentLayout();
    const {userInfo} = this.props;
    const {phoneNumber, country} = userInfo;

    if (this.checkFieldsForErrors()) {
      return false;
    }

    const region = country.iso2.toUpperCase() || "US"
    Analytics.sendClickEvent('user-popup-submit');
    this.fabricatorSettings = this.props.fabricatorData.settings;
    switch (this.state.view) {
      case VIEW.login:
        Analytics.sendClickEvent("user-popup-submit-login");
        userLogin({showConfirmationPopup, showSchedule, quoteRequestType, userPopupType: this.props.userPopupType, checkout: this.props.checkout});
        break;
      case VIEW.register:
        Analytics.sendClickEvent("user-popup-submit-register");
        if (this.props.fabricatorData.settings.twoFA) {
          let isValidPhone = true;
          try {
            isValidPhone = Misc.isPhoneNumber(phoneNumber, region);
          } catch (ex) {
            isValidPhone = false;
          }
          if (!isValidPhone) {
            this.props.changeMessageBoxState({
              visible: true,
              message: "userPopup.phoneError",
              buttons: [{
                text: "userPopup.phoneErrorOkButton",
                color: "blue",
                click: () => {
                  this.props.changeMessageBoxState({visible: false});
                }
              }]
            });
            return;
          }
        }
        userRegister({
          showConfirmationPopup,
          showSchedule,
          quoteRequestType,
          userPopupType: this.props.userPopupType,
          checkout: this.props.checkout,
          noInternetCallBack: this.handleSubmit.bind(this, {showConfirmationPopup, showSchedule, quoteRequestType})
        });
        break;
      case VIEW.reset:
        resetUserPassword();
        break;
      default:
        break;
    }

    layout.updateLocalStorage();
  };

  handleChangeView = (view) => () => {
    Analytics.sendClickEvent('user-popup-change-view-' + view);
    this.setState({
      view
    })
  };

  handleChangeTerms = () => {
    this.setState({
      termsSelected: !this.state.termsSelected
    })
  };

  setInputFocused = (inputFocused) => {
    this.setState({
      inputFocused
    })
  };

  handleAdditionalFieldsShow = () => {
    if (!this.props.employeesListReceived) {
      getEmployees()
    }
    this.props.toggleAdditionalFields(!this.props.showAdditionalFields);
  };

  twoFAOnClose = (cancel, updatedPhoneNumber) => {
    if (updatedPhoneNumber) {
      this.props.setUserPhoneNumberValidated(true);
      $(document).trigger(ActionTypes.USER_IS_LOGGED_IN); // click on the active item it the navigation
    }

    const fabricatorSettings = this.props.fabricatorData.settings;
    this.handleUserPopupToggle(); // close popup
    if(updatedPhoneNumber && !cancel) {
      if (this.props.userPopupType === UserPopupTypes.NewDesign && fabricatorSettings.yesNoConsultationRequest) {
        renderConfirmPopup(ConfirmPopupTypes.ConsultationRequest);
      }
      if(this.props.checkout && fabricatorSettings.checkout && fabricatorSettings.hasPaymentGateway) {
        showCheckoutLayout(fabricatorSettings);
      }
    }
  };

  getTermsText = () => {
    return (
      <div className="user-popup-terms">
        <PrivacyPolicyTerms/>
      </div>
    )
  };

  getUserPopupTitle = () => {
    switch (this.props.userPopupType) {
      case UserPopupTypes.Schedule:
        return <FormattedMessage id="userPopup.title.schedule"/>;
      case UserPopupTypes.GetQuote:
        return <FormattedMessage id="userPopup.title.getQuote"/>;
      case UserPopupTypes.Unlock:
      case UserPopupTypes.NewDesign:
      default:
        return window.location.href.includes("visualizer")
          ? <FormattedMessage id="userPopup.title.visualizer"/>
          : <FormattedMessage id="userPopup.title.quotingTool"/>
    }
  };

  getUserPopupText = (fabricatorSettings) => {
    let textKey = "";
    switch (this.props.userPopupType) {
      case UserPopupTypes.GetQuote:
        textKey = window.location.hash.includes("visualizer") ? "userPopup.subTitle.visualizer" : "userPopup.subTitle.getQuote";
        break;
      case UserPopupTypes.Schedule:
        textKey = window.location.hash.includes("visualizer") ? "userPopup.subTitle.visualizer" : "userPopup.subTitle.schedule";
        break;
      case UserPopupTypes.NewDesign:
        textKey = window.location.hash.includes("visualizer") ? "userPopup.subTitle.visualizer" : "userPopup.subTitle.newDesign";
        break;
      case UserPopupTypes.Unlock:
      default:
        textKey = window.location.hash.includes("visualizer")
          ? "userPopup.subTitle.visualizer"
          : fabricatorSettings.showPricing
            ? "userPopup.subTitle.regular" : "userPopup.subTitle.regularNoPricing";
        break;
    }
    return <FormattedMessage id={textKey}/>
  };

  render() {
    const {userPopupOpened, userIsLoggedIn, isPhoneNumberValidated, userSchedulerOpened} = this.props;
    const fabricatorSettings = this.props.fabricatorData.settings;

    if (userPopupOpened && userIsLoggedIn && fabricatorSettings.twoFA && !document.kvConfig.KioskMode && !isPhoneNumberValidated) {
      return <TwoFAView onClose={this.twoFAOnClose}/>;
    }

    if (userSchedulerOpened) {
      return <ConfirmationScheduleView/>
    }

    const popupStyles = browserIsSafari() && (!document.body.classList.contains('bv--focused') || isIframe()) && this.props.windowWidth < 991
      ? { height: this.props.windowHeight - 35 } : {};

    // const clickLeadCaptureMade = fabricatorSettings.clickLeadCapture
    // && (window.itemClickCount >= fabricatorSettings.clickLeadCount);

    // const getQuoteEnabled = fabricatorSettings.enableQuote && (this.props.userPopupType === UserPopupTypes.GetQuote);

    return userPopupOpened ? (
        <div className="overlay overlay--gray">
          <div className={"user-popup animated bounceIn"
          + (this.state.inputFocused ? " user-popup--input-focused-" + this.state.inputFocused : "")}
               style={popupStyles}>
            <div className="user-popup-header">
              {this.state.view !== VIEW.terms ? (
                <button className="user-popup-header__switch" onClick={this.handleAdditionalFieldsShow}/>
              ) : null}
              <button className="user-popup-header__close ui-close" onClick={this.handleUserPopupToggle}/>
            </div>
            {this.state.view === VIEW.terms ? this.getTermsText() : (
              <div className="user-popup-scrollable">
                <div className="user-popup-body">
                  <UserFields view={this.state.view}
                              handleChangeView={this.handleChangeView}
                              setInputFocused={this.setInputFocused}
                              handleSubmit={this.handleSubmit}/>
                  <div className="user-popup-body__right">
                    <div className="user-popup-photo rotateIn animated">
                      <img className="user-popup-photo__image" src={this.state.imageSrc}/>
                    </div>
                    <div className="user-popup-clip"/>
                    <h3 className="user-popup-newtitle bold">
                      {this.getUserPopupTitle(fabricatorSettings)}
                    </h3>
                    <p className="user-popup-text bold">
                      {this.getUserPopupText(fabricatorSettings)}
                    </p>
                    <div className="user-popup-footer__buttons">
                      {this.props.userPopupType === UserPopupTypes.Unlock ? (
                        <button className="user-popup-footer__button ui-button2 ui-button2--green"
                                onClick={() => this.handleSubmit({quoteRequestType: QuoteRequestType.RegularDesign})}>
                          <FormattedMessage id={
                            this.state.view === VIEW.reset ? "userPopup.buttons.resetPassword" : "userPopup.buttons.unlock"
                          }/>
                        </button>
                      ) : null}
                      {this.props.userPopupType === UserPopupTypes.GetQuote ? (
                        <button className={"user-popup-footer__button ui-button2 ui-button2--green getquotebuttons"}
                                onClick={() => Analytics.sendClickEvent('get-quote-popup-get-quote-button') && this.handleSubmit({quoteRequestType: QuoteRequestType.RequestQuote})}>
                          <FormattedMessage id="userPopup.buttons.getQuote"/>
                        </button>
                      ) : null}
                      {this.props.userPopupType === UserPopupTypes.Schedule
                      || this.props.userPopupType === UserPopupTypes.GetQuote ? (
                        <button className={"user-popup-footer__button ui-button2 ui-button2--green"
                        + (this.props.userPopupType === UserPopupTypes.GetQuote ? " getquotebuttons" : "" )}
                                onClick={() => Analytics.sendClickEvent(this.props.userPopupType === UserPopupTypes.GetQuote ? 'get-quote-popup-schedule-appointment-button' : 'schedule-appointment-popup-schedule-appointment-button') && this.handleSubmit({showSchedule: true, quoteRequestType: QuoteRequestType.ScheduleAnAppointment})}>
                          {/*Schedule Appointment*/}
                          <FormattedMessage id="userPopup.buttons.getQuote"/>
                        </button>
                      ) : null}
                      {this.props.userPopupType === UserPopupTypes.NewDesign ? (
                        <button className={"user-popup-footer__button ui-button2 ui-button2--green getquotebuttons"}
                                onClick={() => Analytics.sendClickEvent('get-quote-email-design') && this.handleSubmit({showConfirmationPopup: fabricatorSettings.yesNoConsultationRequest,
                                  quoteRequestType: QuoteRequestType.RegularDesign})}>
                          <FormattedMessage id="userPopup.buttons.emailDesign"/>
                        </button>
                      ) : null}
                      {this.props.userPopupType === UserPopupTypes.NewDesign ? (
                        <button className="user-popup-footer__button ui-button2 ui-button2--green getquotebuttons"
                                onClick={() => Analytics.sendClickEvent('get-quote-request-quote') && this.handleSubmit({quoteRequestType: QuoteRequestType.RequestQuote})}>
                          <FormattedMessage id="userPopup.buttons.requestQuote"/>
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.view === VIEW.terms ? (
              <div className="user-popup-bottom">
                <p className="user-popup-footer__bottomtext">
                  <label className={"ui-checkbox ui-checkbox--small ui-checkbox--checked"}
                  // + (this.state.termsSelected ? " ui-checkbox--checked" : "")}
                         htmlFor="termsInput"/>
                  <input type="checkbox" id="termsInput" className="ui-checkbox-input"
                         onChange={this.handleChangeTerms} checked={this.state.termsSelected} disabled={true}/>
                  <span onClick={this.handleChangeTerms}><FormattedMessage id="userPopup.termsLabel"/></span>
                </p>
                {this.props.showPrivacyPolicy ? (
                  <button className="ui-button2 ui-button2--green" onClick={this.handleUserPopupToggle}>
                    <FormattedMessage id="userPopup.button.privacyClose"/>
                  </button>
                ) : (
                  <button className="ui-button2 ui-button2--green"
                          onClick={this.handleChangeView(VIEW.register)}>
                    <FormattedMessage id="userPopup.button.continue"/>
                  </button>
                )}
              </div>
            ) : (
              <div className="user-popup-footer">
                {this.state.view === VIEW.login ? (
                  <p className="user-popup-footer__bottomtext"><FormattedMessage id="userPopup.footer.registerText"/> <span
                    onClick={this.handleChangeView(VIEW.register)} className="user-popup-footer__bottomtext-link bold">
                    <FormattedMessage id="userPopup.footer.registerTextLink"/></span>
                  </p>
                ) : null}
                {this.state.view === VIEW.register ? (
                  <p className="user-popup-footer__bottomtext"><FormattedMessage id="userPopup.footer.loginText"/> <span
                    onClick={this.handleChangeView(VIEW.login)} className="user-popup-footer__bottomtext-link bold">
                    <FormattedMessage id="userPopup.footer.loginTextLink"/></span>
                  </p>
                ) : null}
                <p className="user-popup-footer__bottomtext user-popup-footer__bottomtext-link bold"
                   onClick={this.handleChangeView(VIEW.terms)}><FormattedMessage id="userPopup.footer.privacyLink"/>
                </p>
              </div>
            )}
          </div>
        </div>
    ) : null
  }
}

const mapStateToProps = (store) => {
  const {userState, serverState} = store;
  const {bvOpened, bvVisited, staticCanvasImage} = store.bathroomVisualizerState;
  return {
    bvOpened,
    bvVisited,
    staticCanvasImage,
    userIsLoggedIn: userState.userIsLoggedIn,
    isPhoneNumberValidated: userState.isPhoneNumberValidated,
    userPopupOpened: userState.userPopupOpened,
    userInfo: userState.userInfo,
    windowWidth: serverState.windowWidth,
    windowHeight: serverState.windowHeight,
    employeesListReceived: userState.employeesListReceived,
    showAdditionalFields: userState.showAdditionalFields,
    fabricatorData: store.fabricatorState,
    userSchedulerOpened: userState.userSchedulerOpened,
    userPopupType: userState.userPopupType,
    checkout: userState.checkout,
    showPrivacyPolicy: userState.showPrivacyPolicy,
  };
};

const mapDispatchToProps = {
  toggleUserPopup,
  toggleAdditionalFields,
  setUserPhoneNumberValidated,
  changeMessageBoxState,
  changeUserInfoErrors,
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(UserPopup)
)
